import { render, staticRenderFns } from "./WebhookEvents.vue?vue&type=template&id=32047137&"
import script from "./WebhookEvents.vue?vue&type=script&lang=ts&"
export * from "./WebhookEvents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports